import { InfoCircleOutlined } from "@ant-design/icons";
import { Tooltip, Row, Col } from "antd";

const InfoPanel = (props) => {
    return (
        <>
        <div className="info-panel"> 
            <Row>
                <Col className="gutter-row" span={12}><p className="propName">Class </p></Col>
                <Col className="gutter-row" span={12}><p className="propValue">{props.nodeClass}</p></Col>
            </Row>
            {props.nodeClass != "Dummy" && <>
                <Row>
                    <Col className="gutter-row" span={12}><p className="propName">Vertex Count </p></Col>
                    <Col className="gutter-row" span={12}><p className="propValue">{props.vertexCount}</p></Col>
                </Row>
                <Row>
                    <Col className="gutter-row" span={12}><p className="propName">Polygon Count </p></Col>
                    <Col className="gutter-row" span={12}><p className="propValue">{props.polygonCount}</p></Col>
                </Row>
                <Row>
                    <Col className="gutter-row" span={12}><p className="propName">Quads </p></Col>
                    <Col className="gutter-row" span={12}><p className="propValue">{props.quadsCount}</p></Col>
                </Row>
                <Row>
                    <Col className="gutter-row" span={12}><p className="propName">Tris </p></Col>
                    <Col className="gutter-row" span={12}><p className="propValue">{props.triCount}</p></Col>
                </Row>
                <Row>
                    <Col className="gutter-row" span={12}><p className="propName">N-Gons </p></Col>
                    <Col className="gutter-row" span={12}><p className="propValue">{props.ngonsCount}</p></Col>
                </Row>
                <Row>
                    <Col className="gutter-row" span={12}><p className="propName">Material Name </p></Col>
                    <Col className="gutter-row" span={12}><p className="propValue">{props.materialName}</p></Col>
                </Row>
                <Row>
                    <Col className="gutter-row" span={12}><p className="propName">Material Class </p></Col>
                    <Col className="gutter-row" span={12}><p className="propValue">{props.materialClass}</p></Col>
                </Row>
                {props.modifiers && <Row>
                    <Col className="gutter-row" span={12}><p className="propName">Modifiers </p></Col>
                    <Col className="gutter-row" span={12}><p className="propValue">{props.modifiers}</p></Col>
                </Row>}</>}
                {props.texelDensity && <Row>
                    <Col className="gutter-row" span={18}>
                    <p className="propName propContainer">Texel Density ( px / cm )
                        <Tooltip title="Texel Density values are with respect to a map size of 1024x1024 px"><InfoCircleOutlined className="propInfo"/></Tooltip>
                    </p>
                    </Col>
                    <Col className="gutter-row" span={6}><p className="propValue">{props.texelDensity}</p></Col>
                </Row>
                }

        </div>
        </>
    );
};
export default InfoPanel;